<template>
  <div id="log-in-page" class="main-page">
    <div class="container">
      <div class="row row-login-form">
        <div class="col-xl-6 col-lg-6 col-md-5 col-sm-12 text-center col-login-left">
          <img class="login-img" :src="login_img" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-login-right">
          <p class="login-title">Password Reset</p>
          <div v-if="!success">
            <div class="account-form-input">
              <passwordInputBase label="New Password" v-model="password" :nameclass="{
                    'register-input': !$v.password.$error,
                  }" />
            </div>
            <div class="account-form-input">
              <basePasswordResetBase label="Repeat Password" v-model="repeatPassword" />
              <div
                class="account-error-message"
                v-if="!$v.repeatPassword.sameAsPassword && repeatPassword.length > 0"
              >Passwords must be identical.</div>
            <div
                class="account-error-message"
                v-else-if="err_msg"
              >{{err_msg}}</div>
            </div>
            
          </div>
          <div v-else>
            <p>your reset password is success, you can log in now</p>
          </div>
          
          <div class="form-btn-section text-center">
            <button v-if="!success" class="blue-cta" type="submit" @click="on_submit()" :disabled="!$v.repeatPassword.sameAsPassword 
            || repeatPassword.length === 0 || password.length === 0 ">Update Your Password</button>
            <button v-else class="blue-cta" type="submit" @click="to_login()">Login</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { passwordInputBase ,basePasswordResetBase} from "../components/forms/baseForms";
export default {
  components: {
    passwordInputBase,
    basePasswordResetBase
  },
  created() {
    this.key = this.$route.params.key;
  },
  data() {
    return {
      login_img: require("@/assets/images/login.png"),
      password: "",
      repeatPassword: "",
      key: "",
      success: false,
      err_msg:null
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(6)
    },
    repeatPassword: {
      sameAsPassword: sameAs("password")
    }
  },
  methods: {
    error_pop(){
      this.err_msg =""
    },
    on_submit() {
      this.$store
        .dispatch("resetPassword", {
          key: this.key,
          password: this.password
        })
        .then(response => {
          if (response.status == 200) {
            this.$router.push({ name: "login", query: { message: "resetcomplete" } })
          }
        })
        .catch(error => {
          if (error.data.hasOwnProperty('password') && !error.data.hasOwnProperty('key')){
            this.err_msg =`${error.data.password[0]}`
          }else if(error.data.hasOwnProperty('key')&& !error.data.hasOwnProperty('password')){
            this.err_msg ="Invalid uuid, please resend reset password request"
          }else if(error.data.hasOwnProperty('password') && error.data.hasOwnProperty('key')){
            this.err_msg =`${error.data.password[0]}`
          }else{
             this.err_msg ="Something when wrong"
          }
          setTimeout(()=>{this.error_pop()},6000)
        });
    },
    to_login(){
      this.$router.push(
        { name:'login' }
      )
    }
  },
   watch: {
      err_msg: function (update, old){
        if (update ==="") {
          this.err_msg=false
        }
      },
  }
};
</script>

<style scoped>
.login-img {
  width: 405px;
  padding-top: 30px;
}
</style>